var exports = {
  "iE": "xaee3c4fa--92e514--wrapper",
  "TI": "xaee3c4fa--92e514--search-and-regions-wrapper",
  "A1": "xaee3c4fa--92e514--_active",
  "f$": "xaee3c4fa--92e514--top-margin",
  "Wz": "xaee3c4fa--92e514--group-wrapper",
  "DD": "xaee3c4fa--92e514--title",
  "r8": "xaee3c4fa--92e514--content-type-wrapper",
  "$g": "xaee3c4fa--92e514--tag-scrolling-wrapper",
  "MY": "xaee3c4fa--92e514--bread-crumbs-wrapper",
  "nW": "xaee3c4fa--92e514--ordering-buttons-wrapper",
  "MJ": "xaee3c4fa--92e514--listing-type-wrapper",
};

module.exports = exports;
